import React, { useState } from "react";
import aiImage from "../../../assets/DigitalMarketing.jpg";
import SEOComponent from "../../SEOComponent";
import OptimizedImage from "../../OptimizedImage";
import strategyImage from "../../../assets/Demand-Generation2.jpeg";
import customImage from "../../../assets/SEO.jpg";
import genaiImage from "../../../assets/SMM-2.jpg";
import agenticImage from "../../../assets/EMAIL1.jpg";
import ethicalImage from "../../../assets/VM1.jpeg";
import researchImage from "../../../assets/IM1.jpg";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

export default function DigitalMarketing() {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      title: "Demand Generation & Sales Pipelines",
      image: strategyImage,
      link: "/solutions/digital-marketing/demand-generation",
      content:
        "Launch multi-touch digital campaigns, nurture leads through funnels, and optimize conversion.",
    },
    {
      title: "Search Engine Optimization SEO",
      image: customImage,
      link: "/solutions/digital-marketing/seo",
      content:
        "Enhance organic visibility through technical SEO, keyword strategy, and performance insights.",
    },
    {
      title: "Social Media Marketing (SMM)",
      image: genaiImage,
      link: "/solutions/digital-marketing/smm",
      content:
        "Curate engaging social content strategies and run targeted ad campaigns across platforms.",
    },
    {
      title: "Email & Content Marketing",
      image: agenticImage,
      link: "/solutions/digital-marketing/content-marketing",
      content:
        "Develop automated email journeys and SEO-rich, AI-powered blogs, whitepapers, and guides.",
    },
    {
      title: "Video Marketing",
      image: ethicalImage,
      link: "/solutions/digital-marketing/video-marketing",
      content:
        "Create promotional videos, explainers, reels, and corporate stories that elevate brand recall.",
    },
    {
      title: "Influencer Marketing",
      image: researchImage,
      link: "/solutions/digital-marketing/influencer-marketing",
      content:
        "Partner with regional influencers to amplify campaigns using vetted creator networks.",
    },
  ];

  return (
    <div className="bg-gradient-to-br from-black via-gray-900 to-black">
      <SEOComponent 
        title="Digital Marketing Services - SEO, Social Media & Content Marketing | AlifShams"
        description="Comprehensive digital marketing services in Dubai, UAE including SEO, social media marketing, demand generation, email marketing, video marketing, and influencer marketing. Drive measurable results with data-driven strategies."
        keywords="digital marketing Dubai, SEO services UAE, social media marketing Dubai, demand generation UAE, email marketing Dubai, content marketing UAE, video marketing Dubai, influencer marketing UAE, digital advertising Dubai, online marketing UAE"
        url="https://digitalif.net/solutions/digital-marketing"
        type="service"
      />
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <OptimizedImage
            src={aiImage}
            alt="Digital Marketing"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Digital Marketing
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            We use data, creativity, and technology to power marketing that
            delivers measurable demand and brand equity.
          </p>
        </div>
      </section>

      {/* Overview Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-white">
            Data-Driven Marketing Excellence
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed">
            We use data, creativity, and technology to power marketing that
            delivers measurable demand and brand equity.
          </p>
        </div>
      </section>

      {/* Services & Content Section */}
      <section className="py-8 sm:py-12 md:py-16 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            {/* Services - Left Side */}
            <div className="flex-1">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-6 sm:mb-8 text-white text-center lg:text-left">
                Our Marketing Services
              </h3>
              <div className="space-y-3">
                {services.map((service, index) => (
                  <div
                    key={index}
                    onClick={() => setActiveService(index)}
                    className={`p-4 rounded-lg cursor-pointer transition-all ${
                      activeService === index
                        ? "bg-[#B31F7E] text-white shadow-lg"
                        : "bg-gray-800 text-white hover:bg-gray-700"
                    }`}
                  >
                    <span className="font-medium">{service.title}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Vertical Line */}
            <div className="hidden lg:block w-px h-96 bg-gray-600"></div>

            {/* Content - Right Side */}
            <div className="flex-1">
              <div className="bg-gray-800 rounded-lg shadow-lg overflow-hidden">
                <OptimizedImage
                  src={services[activeService].image}
                  alt={services[activeService].title}
                  className="w-full h-40 sm:h-48 object-cover"
                />
                <div className="p-4 sm:p-6">
                  <h4 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-white">
                    {services[activeService].title}
                  </h4>
                  <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
                    {services[activeService].content}
                  </p>
                  <div className="mt-5">
                    <Link to={services[activeService].link}>
                      <Button className="!bg-[#B31F7E] !text-white">
                        Know More
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Digital Marketing Services Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-12 text-white text-center">
            Digital Marketing Services
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Digital Marketing Strategy Creation */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">Digital Marketing Strategy Creation</h3>
              <p className="text-sm text-gray-300 mb-4">
                Our Digital Marketing Strategists craft in-depth strategies for businesses in all sectors.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                Strategies include customer modelling, customer journeys, lead generation opportunities and marketing messaging together with a full analysis and audit of your web / mobile and social assets.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
            
            {/* Website Design & Development */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">Website Design & Development</h3>
              <p className="text-sm text-gray-300 mb-4">
                Our experienced team of project managers, website designed, user experience specialists and developers work cohesively to create award-winning websites for our clients.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                We've created over 1,500 websites for a wide range of clients and industries since 2005.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
            
            {/* Social Media Marketing */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">Social Media Marketing</h3>
              <p className="text-sm text-gray-300 mb-4">
                Social media is a vital aspect of marketing a business online, both through organic methods and paid advertising. Effective management of social media results in a solid brand image and the capacity to connect and communicate with your target audience directly.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                We specialize in all aspects of social media, including community management, social media advertising and campaigns.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
            
            {/* HubSpot & Inbound Marketing */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">HubSpot & Inbound Marketing Services</h3>
              <p className="text-sm text-gray-300 mb-4">
                HubSpot is a CRM platform that includes the necessary software, integrations, and resources for integrating marketing, sales, content management, and customer service.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                As a HubSpot Diamond Agency Partner, we are within the top 2% of HubSpot partners worldwide, with extensive experience across various industries and a team of experts who are proficient in both HubSpot and CRM.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
            
            {/* Search Engine Optimisation */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">Search Engine Optimisation</h3>
              <p className="text-sm text-gray-300 mb-4">
                SEO is a vital component of the lead generation and conversion process and can greatly impact the overall success of a website. The role of SEO is to ensure that your business is visible to customers or prospects when they search for your offerings and attract cost-effective traffic through SEO.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                As SEO specialists with nearly two decades of experience, ALIF follows a tried and tested process for SEO services that we continually improve and refine to maximize the results of online campaigns. This leads to an increase in traffic, sales, and business growth. Our team has won a number of industry awards for our SEO work.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
            
            {/* Lead Generation Services */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">Lead Generation Services</h3>
              <p className="text-sm text-gray-300 mb-4">
                Does your business need qualified sales leads? Look no further. For nearly two decades, ALIF has been providing businesses of all types with top-notch sales leads. Their expertise, advanced technology, and successful track record make them the perfect partner for boosting your business growth with effective and innovative inbound marketing strategies.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                ALIF has partnerships with major media and advertising platforms, including being a Google Premier Partner, Meta Partner, LinkedIn Partner, Snapchat Partner, and TikTok Partner. This access to large, targeted audiences allows ALIF to use engaging content and creative strategies to turn potential customers into high-quality sales leads.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
            
            {/* Video Production Services */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">Video Production Services</h3>
              <p className="text-sm text-gray-300 mb-4">
                Video content is a highly valuable tool that continues to grow in popularity. It is a crucial aspect of digital marketing and has the ability to drive growth for your business. Your videos should effectively convey your brand's message and capture your audience's attention.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                Our talented content creators are eager to bring your brand to life through engaging video content that truly embodies your unique essence and appeals to your customers.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
            
            {/* Web 3.0 & NFT Services */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">Web 3.0 & NFT Services</h3>
              <p className="text-sm text-gray-300 mb-4">
                A shift is on the horizon. Similar to the impact of the internet's arrival nearly 30 years ago, a new movement is rapidly gaining momentum and will soon challenge the current digital and business landscape.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                ALIF is ahead of the curve, offering a variety of services for top brands as they navigate the Web 3.0 arena.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
            
            {/* Metaverse Services */}
            <div className="bg-black border border-gray-600 p-6 rounded-lg shadow-lg hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-lg font-bold text-[#B31F7E] mb-4">Metaverse Services</h3>
              <p className="text-sm text-gray-300 mb-4">
                The Metaverse is generating a lot of excitement lately, presenting opportunities for brands to connect with their audiences through a novel, virtual platform.
              </p>
              <p className="text-sm text-gray-300 mb-6 flex-grow">
                At ALIF, we help companies clarify the opportunities within each Metaverse and determine the right platform to meet their needs.
              </p>
              <Link to="/contact" className="bg-[#B31F7E] text-white px-4 py-2 rounded hover:bg-[#9A1A6B] transition-colors mt-auto text-center">
                Speak to Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Working with ALIF Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-900">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-8 text-white text-center">
            Working with ALIF - A Digital Marketing Agency
          </h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Working with a Digital Marketing Agency to develop and manage your business's online reputation can make or break a business. It entails not only what your business creates and shares, but also encouraging your customers to share their experiences and join your online community. Other benefits of this form of marketing include the highly targeted tools available, as well as the ability to provide customer support - in other words, opportunities too good to be missed by a business.
              </p>
              
              <p className="text-gray-300 mb-6 leading-relaxed">
                When working with a Digital Marketing Agency, they will cater to your specific needs, since not all digital marketing methods will be applicable to you. However, having a well rounded and well-executed strategy is paramount. The agency you work with should be experienced in your industry, with a portfolio of work to show for it. We invite you to have a look at the businesses we've worked with, assisting them with various marketing services that have helped them level up.
              </p>
            </div>
            
            <div>
              <p className="text-gray-300 mb-6 leading-relaxed">
                When the Digital Marketing Agency begins working with you, they will develop a strategy which includes specific goals and plans. It includes extensive research and will map out your business's planned digital footprint. They will then call on their team of creatives to work on the content creation, which should be designed to satisfy and convert your audiences. It will include various forms of digital marketing, with the focus being placed on leads.
              </p>
              
              <p className="text-gray-300 leading-relaxed">
                Your team of marketers will place a keen interest in developing relationships with your audience. Providing value and encouraging engagement is of the utmost importance, which is then followed by reporting on their results. Analysis and insights are a final yet paramount task for marketers to illustrate what they have been able to achieve with acute accuracy, as that is one of digital marketing's most valued benefits.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
